import React from "react";
import { Message, TextArea } from "semantic-ui-react";

const TextInputForm = (props, { ...form }) => {
  return (
    <div style={{}}>
      <TextArea
        onChange={props.onChange}
        placeholder="Answer Text"
        type={props.type}
        fluid
        size="small"
        value={props.value}
        min={props.min}
        step={props.step}
        maxLength={props.maxLength}
        max={props.max}
        disabled={props.disabled}
        style={{ backgroundColor: "#F6F6F6" }}
      />
      {props.isError && props.isTouched && (
        <Message visible error content={props.isError} />
      )}
    </div>
  );
};

export default TextInputForm;
